import React, { useState, useEffect, useContext } from "react"
import { motion, AnimatePresence } from "framer-motion"
import logo from "../../assets/tap2tech/logo.png"
import { Upload, Button } from "antd"
import { UploadOutlined } from "@ant-design/icons"
import ImgCrop from "antd-img-crop"
import { FirebaseFuntions } from "../../context/FirebaseContext"

const MainCointainer = ({user, projectLogo}) => {
    const { uploadPhoto, uploadBanner, createUserAdmin, readUserAdmin, deleteUserAdmin, updateUserAdmin } = useContext(FirebaseFuntions)
    const { banner, name, lastname } = user     
    const [isBig, setIsBig] = useState(false)
    const [alertStatus, setAlertStatus] = useState("")
    const [updateAlert, setUpdateAlert] = useState(false)
    const [userId, setUserId] = useState("")
    const [users , setUsers] = useState([])
    const [isChanged, setIsChanged] = useState(false)
    const [photoIsAdded, setPhotoIsAdded] = useState(false)
    const [isConfirmed, setIsConfirmed] = useState(false)
    const [isBulk, setIsBulk] = useState(0)
    const [fileData, setFileData] = useState(null)
    const [userData, setUserData] = useState(null)
    

    const handleSubmit = (e) => {        
        e.preventDefault()
        const datos =  Array.from(new FormData(e.target))
        const obj = Object.fromEntries(datos)  
        console.log(obj)
        if (userData) {
            const resultado = updateUserAdmin(obj)
            resultado.then((res) => {
                console.log(res)
                setAlertStatus("Datos Actualizados: " + res)
                handleAlert()
                setIsChanged(!isChanged)
            })
        } else {
            const resultado = createUserAdmin(obj)
            resultado.then((res) => {
                console.log(res)
                setAlertStatus("Datos confirmados: " + res)
                handleAlert()
                setIsConfirmed(true)
            }) 
        } 
        setUserData(null)   
        // reset form
        e.target.reset()
    }

    const userLicense = (users) => {
        const total = 126
        const id = "usuario_"
        const existingSlugs = new Set(users.map((user) => user.userId))
        for (let i = 0; i <= total; i++) {
            const slug = id + i
            if (!existingSlugs.has(slug)) {
                return slug
            }
        }
        return null

    }

    const handleBanner = (e) => {
        const extData = String(e.type).replace("image/", ".")
        //const url = URL.createObjectURL(e)
        if (e.size > 2097152) {
            setIsBig(true)
        } else {
            setIsBig(false)
            const resultado = uploadBanner(e, userId+"banner"+extData , userId, "gedeon")
            resultado.then((res) => {
                setAlertStatus(res)
                handleAlert()
                setIsChanged(!isChanged)
            })
        }
        return false
    }

    const handleUpload = (e) => {
        const extData = String(e.type).replace("image/", ".")
        //const url = URL.createObjectURL(e)
        if (e.size > 2097152) {
            setIsBig(true)
        } else {
            setIsBig(false)
            const resultado = uploadPhoto(e, userId+"photo"+extData , userId, "gedeon")
            resultado.then((res) => {
                setAlertStatus(res)
                handleAlert()
                setIsChanged(!isChanged)
            })
        }
        return false
    }

    
    const handleCsv = async () => {        
        if (fileData === null) {
            setAlertStatus("No se ha seleccionado un archivo")
            handleAlert()
            return false
        } else {
            console.log(fileData)
            const fileurl = URL.createObjectURL(fileData)
            const response = await fetch(fileurl)
            const data = await response.text()
            const rows = data.split(/\r?\n|\r/)
            const headers = rows[0].split(",")
            const cols = rows.slice(1)        
            //console.log(headers)
            cols.map((col) => {
                const values = col.split(",")
                const obj = {}
                headers.map((header, index) => {
                    obj[header] = values[index] !== "" ? values[index] : null
                    return true
                })
                //console.log(obj)
                const resultado = createUserAdmin(obj)
                resultado.then((res) => {                
                    console.log("Datos confirmados: " + res)                
                })
                return true
            })
            handleAlert()
            setAlertStatus("Usuarios creados")
            setIsConfirmed(false)
            setIsChanged(!isChanged)
        }
    }

    const handleAlert = () => {
        setUpdateAlert(true)
        setTimeout(() => {
            return setUpdateAlert(false)
        }, 5000);
    }

    useEffect(() => {
        
        const resultado = readUserAdmin()
        resultado.then((res) => {            
            setUsers(res)  
            const data = userLicense(res)
            setUserId(data)                
        })
    },[ readUserAdmin, isChanged ])

    return (
        <main className="flex flex-col justify-around md:p-10 sm:p-5">
            <AnimatePresence>
                {updateAlert && 
                    <motion.div 
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className={`w-full bg-green-500 p-2 fixed top-0 flex justify-center items-center z-50`}>
                        <span className="text-md text-white font-medium uppercase text-center w-full">{alertStatus}</span>
                    </motion.div>
                } 
            </AnimatePresence>
            <section className="flex md:justify-start  sm:justify-center md:mb-8 sm:mb-8">
                <div className="md:w-2/5 sm:w-full flex items-center justify-start">
                    <motion.img
                        initial={{opacity: 0, y: -100}}
                        animate={{opacity: 1, y: 0}}
                        transition={{duration: 1, ease: "easeInOut"}}
                        className="md:scale-100 sm:scale-50 md:max-w-[300px] max-h-[100px] sm:max-w-[200px]"
                        src={banner ? banner : (projectLogo?.logo ? projectLogo?.logo : logo)} alt="logo"/>
                </div>
            </section>
            <section className="flex md:justify-start md:flex-row sm:flex-col  sm:justify-center">
                <div className="w-3/5 p-4">
                    <h1 className="text-3xl font-bold text-gray-800 mb-8">¡Bienvenido {name} {lastname}!</h1>
                    <h2 className="text-xl font-semibold text-gray-800 uppercase mb-2">Crear usuario</h2>
                    <p className="text-sm text-gray-800 mb-2">
                        Seleccione el tipo de carga que desea realizar.
                    </p>
                    <div className="flex flex-row items-center justify-start mb-5">
                        <button
                            className={`bg-tap2tech_sec text-black font-bold py-2 px-4 rounded-lg uppercase focus:outline-none font-body w-[200px] mr-2 ${isBulk === 2 && "opacity-70"}`}
                            onClick={() => {
                                setIsBulk(1)
                            }}
                        >
                            Carga individual
                        </button>
                        <button
                            className={`bg-tap2tech_sec text-black font-bold py-2 px-4 rounded-lg uppercase focus:outline-none font-body w-[200px] mr-2 ${isBulk === 1 && "opacity-70"}`}
                            onClick={() => {
                                setIsBulk(2)
                            }}
                        >
                            Carga masiva
                        </button>
                    </div>
                    {
                        isBulk === 1 &&
                        <>
                            <div className="text-sm text-gray-800 mb-8">
                                <p className="mb-2">
                                    El proceso requiere de tres pasos para completar un perfil:
                                </p>
                                <ul className="list-disc list-inside">
                                    <li className="mb-2">El primer paso es llenar los datos personales.</li>
                                    <li className="mb-2">El segundo paso es agregar una foto de perfil.</li>
                                    <li className="mb-2">El tercer paso es confirmar los datos y crear el usuario.</li>
                                </ul>
                                <p className="mt-2">
                                    Una vez que hayas completado los tres pasos, el usuario se creará automáticamente y podrás verlo en la lista de usuarios activos.
                                </p>
                            </div>
                            <h3 className="text-lg text-gray-800 uppercase mb-8">1. Datos personales</h3>
                            <form className="flex flex-col md:items-start sm:items-center" onSubmit={handleSubmit}>
                                <div className="w-full flex flex-col mb-5 items-center justify-center p-2">
                                    <label className="text-sm font-medium text-left uppercase font-body w-full px-2" htmlFor="slug">UsuarioID</label>
                                    <input className="w-full border-2 border-gray-300 rounded-md p-2 mx-2" type="text" id="slug" name="slug" placeholder="Slug de usuario"
                                        onChange={(e)=>{
                                            console.log(e.target.value)
                                            setUserId(e.target.value)
                                        }}
                                        defaultValue={userId}   
                                        value={userData?.userId}                                        
                                        required                               
                                    />
                                </div>                        
                                <div className="w-full flex flex-row mb-5 items-center justify-center">
                                    <input className="w-1/2 border-2 border-gray-300 rounded-md p-2 mx-2" type="text" id="name" name="name" placeholder="Nombre" required defaultValue={userData?.name}/>
                                    <input className="w-1/2 border-2 border-gray-300 rounded-md p-2 mx-2" type="text" id="lastname" name="lastname" placeholder="Apellido" required defaultValue={userData?.lastname}/>
                                </div>
                                <div className="w-full flex flex-row mb-5 items-center justify-center">
                                    <input className="w-1/2 border-2 border-gray-300 rounded-md p-2 mx-2" type="text" id="job" name="job" placeholder="Puesto" required defaultValue={userData?.job}/>
                                    <input className="w-1/2 border-2 border-gray-300 rounded-md p-2 mx-2" type="text" id="web" name="web" placeholder="Sitio Web" required defaultValue={userData?.web}/>
                                </div>
                                <div className="w-full flex flex-row mb-5 items-center justify-center">
                                    <input className="w-1/2 border-2 border-gray-300 rounded-md p-2 mx-2" type="email" id="email" name="email" placeholder="Mail" required defaultValue={userData?.email}/>
                                    <input className="w-1/2 border-2 border-gray-300 rounded-md p-2 mx-2" type="tel" id="phone" name="phone" placeholder="Teléfono" required defaultValue={userData?.phone}/>
                                </div>
                                <div className="w-full flex flex-row mb-5 items-center justify-center">
                                    <div className="w-1/2 flex flex-col">
                                        <label className="text-sm font-medium text-left uppercase font-body w-full px-2" htmlFor="role">Nivel de usuario</label>
                                        <select className=" border-2 border-gray-300 rounded-md p-2 mx-2" name="role" id="role" defaultValue={userData?.role} required>
                                            <option value="subadmin">Administrador</option>
                                            <option value="user">Usuario</option>
                                        </select>
                                    </div>
                                    <div className="w-1/2 flex flex-col">
                                        <label className="text-sm font-medium text-left uppercase font-body w-full px-2" htmlFor="role">Estilo de perfil (Tema)</label>
                                        <select className="border-2 border-gray-300 rounded-md p-2 mx-2" name="template" id="template" defaultValue={userData?.template} required>
                                            <option value="promo">Default</option>
                                            <option value="luxury">Elegante</option>
                                        </select>
                                    </div>
                                </div>                        
                                <h3 className="text-lg text-gray-800 uppercase mb-8">Redes sociales</h3>  
                                <div className="border-gray-300 border-2 rounded-lg p-3 mb-2 w-full">
                                    <label className="block mb-2 text-sm font-medium text-left uppercase font-body" htmlFor="video">Video</label>
                                    <input className="mb-1 w-full rounded-lg p-3 focus:outline-none font-body border-gray-300" type="text" id="video" name="video" placeholder="Video de usuario" defaultValue={userData?.video}/>
                                    <p className="mx-3 text-[12px] text-left">Agregar únicamente el URL ejemplo:<br/><span className="font-bold">https://youtu.be/XFkACMFj8dI</span></p>                                    
                                </div>                       
                                <div className="border-gray-300 border-2 rounded-lg p-3 mb-2 w-full">
                                    <label className="block mb-2 text-sm font-medium text-left uppercase font-body" htmlFor="linkedin">LinkedIn</label>
                                    <input className="mb-1 w-full rounded-lg p-3 focus:outline-none font-body border-gray-300" type="text" id="linkedin" name="linkedin" placeholder="Usuario de LinkedIn" defaultValue={userData?.linkedin}/>
                                    <p className="mx-3 text-[12px] text-left">Agregar únicamente el usuario, ejemplo:<br/>De la dirección <span className="font-bold">linkedin.com/in/juanlopez.sanchez</span> únicamente ingresar <span className="font-bold">juanlopez.sanchez</span></p>                                    
                                </div>                                                          
                                <div className="border-gray-300 border-2 rounded-lg p-3 mb-2 w-full">
                                    <label className="block mb-2 text-sm font-medium text-left uppercase font-body" htmlFor="twitter">X (Twitter)</label>
                                    <input className="mb-1 w-full rounded-lg p-3 focus:outline-none font-body border-gray-300" type="text" id="twitter" name="twitter" placeholder="Usuario de Twitter" defaultValue={userData?.twitter}/>
                                    <p className="mx-3 text-[12px] text-left">Agregar únicamente el usuario, ejemplo:<br/>De la dirección <span className="font-bold">twitter.com/juanlopez.sanchez</span> únicamente ingresar <span className="font-bold">juanlopez.sanchez</span></p>                                    
                                </div>
                                <div className="border-gray-300 border-2 rounded-lg p-3 mb-2 w-full">
                                    <label className="block mb-2 text-sm font-medium text-left uppercase font-body" htmlFor="instagram">Instagram</label>
                                    <input className="mb-1 w-full rounded-lg p-3 focus:outline-none font-body border-gray-300" type="text" id="instagram" name="instagram" placeholder="Usuario de Instagram" defaultValue={userData?.instagram}/>
                                    <p className="mx-3 text-[12px] text-left">Agregar únicamente el usuario, ejemplo:<br/>De la dirección <span className="font-bold">instagram.com/juanlopez.sanchez</span> únicamente ingresar <span className="font-bold">juanlopez.sanchez</span></p>
                                </div>
                                <div className="border-gray-300 border-2 rounded-lg p-3 mb-2 w-full">
                                    <label className="block mb-2 text-sm font-medium text-left uppercase font-body" htmlFor="facebook">Facebook</label>
                                    <input className="mb-1 w-full rounded-lg p-3 focus:outline-none font-body border-gray-300" type="text" id="facebook" name="facebook" placeholder="Usuario de Facebook" defaultValue={userData?.facebook}/>
                                    <p className="mx-3 text-[12px] text-left">Agregar únicamente el usuario, ejemplo:<br/>De la dirección <span className="font-bold">facebook.com/juanlopez.sanchez</span> únicamente ingresar <span className="font-bold">juanlopez.sanchez</span></p>
                                </div>
                                <motion.button
                                    whileHover={{scale: 1.03}}
                                    whileTap={{scale: 0.9}}
                                    transition={{ type: "spring", stiffness: 400, damping: 17 }}
                                    className="bg-tap2tech_sec text-black font-bold my-3 py-2 px-4 rounded-lg uppercase focus:outline-none font-body"
                                    type="submit"
                                >
                                    Confirmar datos
                                </motion.button> 
                                <h3 className="text-lg text-gray-800 uppercase mt-8 mb-2">2. Actualización de fotos</h3>
                                {
                                    !photoIsAdded &&
                                    <div>
                                        <p className="text-sm text-gray-800 mb-2">
                                            ¿Deseas agregar una foto de perfil?
                                        </p>
                                        <div className="flex flex-row items-center justify-start">
                                            <button
                                                className="bg-tap2tech_sec text-black font-bold w-[180px] py-2 px-4 rounded-lg uppercase focus:outline-none font-body"
                                                onClick={() => {
                                                    setPhotoIsAdded(true)
                                                }}
                                            >
                                                Agregar foto
                                            </button>
                                        </div>
                                    </div>
                                }
                                {
                                    photoIsAdded &&
                                    <div className="flex md:flex-row sm:flex-col w-full mb-5 border-2 border-gray-300 p-4 rounded-md">
                                        <div className="m-1 md:w-1/2 sm:w-full">
                                            <label className="block mb-2 text-sm font-medium text-left uppercase font-body" htmlFor="file_input">Subir Foto<br/><span className="text-[12px]">(Cuida que la imagen sea cuadrada)</span></label>
                                            <span className="text-sm font-medium uppercase">{isBig && ( "El archivo es demasiado pesado" )}</span>                                        
                                            <ImgCrop rotationSlider={true} aspect={1} quality={0.7} modalTitle="Recorta tu imagen" modalOk="Guardar" modalCancel="Cancelar" >
                                                <Upload showUploadList={false} accept="image/png, image/jpeg, image/jpg" beforeUpload={handleUpload} className="w-full flex">
                                                    <Button icon={<UploadOutlined/>} className="w-full font-body">Seleccionar imagen</Button>
                                                </Upload>
                                            </ImgCrop>
                                            <p className="mt-1 text-sm text-left font-body" id="file_input_help">PNG, JPG o JPGE (MAX. 2MB).</p>
                                        </div> 
                                        <div className="m-1 md:w-1/2 sm:w-full">
                                            <label className="block mb-2 text-sm font-medium text-left uppercase font-body" htmlFor="file_input">Seleccionar Logo<br/><span className="text-[12px]">(Considera una imagen rectangular)</span></label>
                                            <span className="text-sm font-medium uppercase">{isBig && ( "El archivo es demasiado pesado" )}</span>                                        
                                            <ImgCrop quality={0.4} modalTitle="Recorta tu imagen" modalOk="Guardar" modalCancel="Cancelar" aspect={15/2} rotationSlider aspectSlider showReset fillColor="transparent" >
                                                <Upload showUploadList={false} accept="image/png, image/jpeg, image/jpg" beforeUpload={handleBanner} className="w-full flex">
                                                    <Button icon={<UploadOutlined/>} className="w-full font-body">Seleccionar logo</Button>
                                                </Upload>
                                            </ImgCrop>
                                            <p className="mt-1 text-sm text-left font-body" id="file_input_help">PNG, JPG o JPGE (MAX. 2MB).</p>
                                        </div> 
                                    </div>    
                                }               
                            </form>
                            <h3 className="text-lg text-gray-800 uppercase mb-2 mt-10">3. Confirmar y crear usuario</h3>
                            <p className="text-sm text-gray-800 mb-2">
                                Para habilitar el botón de confirmación, es necesario que hayas completado los pasos anteriores.
                            </p>
                            <motion.button 
                                whileHover={{scale: 1.03}}
                                whileTap={{scale: 0.9}}
                                className={`bg-yellow-200 text-black font-bold py-2 px-4 rounded-lg uppercase focus:outline-none font-body ${!isConfirmed && "opacity-50 cursor-not-allowed"}`}
                                disabled={!isConfirmed}
                                onClick={() => {
                                    setIsChanged(!isChanged)
                                }}
                            >
                                Confirmar y crear usuario
                            </motion.button> 
                        </>                        
                    }
                    {
                        isBulk === 2 &&
                        <>
                            <div className="text-sm text-gray-800 mb-8">
                                <p className="mb-2">
                                    El proceso requiere de dos pasos para subir una lista de usuarios:
                                </p>
                                <ul className="list-disc list-inside">
                                    <li className="mb-2">El primer paso es subir un archivo CSV con los datos de los usuarios.</li>
                                    <li className="mb-2">El segundo paso es confirmar los datos y crear los usuarios.</li>
                                </ul>
                                <p className="mt-2">
                                    Una vez que hayas completado los dos pasos, los usuarios se crearán automáticamente y podrás verlos en la lista de usuarios activos.
                                </p>
                            </div>
                            <h3 className="text-lg text-gray-800 uppercase mb-8">1. Subir archivo CSV</h3>
                            <div className="flex flex-col w-full mb-5 border-2 border-gray-300 p-4 rounded-md justify-center items-start">
                                <div className="m-1 w-full">
                                    <label className="block mb-2 text-sm font-medium text-left uppercase font-body" htmlFor="file_input">Subir Archivo</label>
                                    <span className="text-sm font-medium uppercase">{isBig && ( "El archivo es demasiado pesado" )}</span>                                        
                                    <Upload 
                                        showUploadList={false}
                                        beforeUpload={
                                            (e)=> {
                                                setFileData(e)
                                                setIsConfirmed(true)
                                            }
                                        }
                                        className="w-full flex" accept=".csv"
                                    >
                                        <Button icon={<UploadOutlined/>} className="w-full font-body uppercase">Seleccionar archivo csv</Button>
                                    </Upload>                                    
                                </div> 
                                <button 
                                    className={`bg-yellow-200 text-black mt-2 text-lg font-bold py-2 px-4 rounded-lg uppercase focus:outline-none font-body ${!isConfirmed && "opacity-50 cursor-not-allowed"}`}
                                    disabled={!isConfirmed}
                                    onClick={() => {
                                        handleCsv()
                                    }}
                                >
                                    Confirmar y crear usuarios
                                </button>
                            </div> 
                        </>
                    }
                </div>
                <div className="w-2/5 p-4">
                    <h2 className="text-xl font-semibold text-gray-800 uppercase mb-2">Lista de usuarios activos</h2>
                    <h3 className="text-lg text-gray-800 uppercase mb-8">Total de usuarios: <span className="font-bold">{users.length > 0 && users.length}</span> de <span className="font-bold">126</span></h3>
                    <div className="w-full flex flex-col items-center justify-center">
                        {
                            users.length > 0 && users.map((user, index) => {
                                return (
                                    <div className="flex flex-row items-center justify-center w-full mb-4 bg-gray-300 p-4 rounded-md" key={index}>
                                        <div className="w-4/5">
                                            <p>UsuarioID: {user?.userId}</p>
                                            <p>Usuario: {user?.name} {user?.lastname}</p>
                                            <p>Nivel de usuario: <span className={`${user?.role === 'subadmin' ? 'text-red-600' : 'text-black'}`}>{user?.role === 'subadmin' ? "Administrador" : "Usuario" }</span></p>
                                            <a href={`https://usuarios.tap2.tech/gedeon/${user?.userId}`} target="_blank" rel="noreferrer" className="font-bold hover:underline">Ver perfil</a>
                                        </div>
                                        <div className="w-1/5 flex flex-row items-center justify-center">
                                            <button
                                                title="Editar usuario"
                                                className="mr-2"
                                                onClick={() => {
                                                    console.log(user)
                                                    setUserData(user)     
                                                    console.log(userId)   
                                                    setUserId(user?.userId)                                                                                      
                                                    console.log(user.userId)
                                                }}
                                            >
                                                <svg width="23" height="23" fill="none" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.5 2h-10a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V10.002"></path>
                                                    <path d="M6.5 9h4"></path>
                                                    <path d="M6.5 14h6"></path>
                                                    <path d="m20.5 3-5.998 5.997"></path>
                                                </svg>
                                            </button>
                                            <button
                                                title="Eliminar usuario"
                                                onClick={() => {
                                                    const resultado = deleteUserAdmin(user?.userId)
                                                    resultado.then((res) => {
                                                        setAlertStatus(res)
                                                        handleAlert()
                                                        setIsChanged(!isChanged)
                                                    })
                                                }}
                                            >
                                                <svg width="23" height="23" fill="none" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="m9 4.5.75-3h4.5l.75 3H9Zm12 0H4.5l1.5 18h12l1.5-18H3h18ZM12 9v9-9Zm3.75 0L15 18l.75-9Zm-7.5 0L9 18l-.75-9Z"></path>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                )                                
                            })
                        }  
                    </div>                      
                </div>
            </section>            
        </main>
    )
}

export default MainCointainer